import { Box } from '@mui/material';
import { useMemo } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import RenderAdminConfig from './RenderAdminConfig';
import BackPageButton from 'components/utils/BackPageButton';
import { useConfigQuery } from '@buildwise/libs/configurations';

function AdminCustomConfig() {
  const { configName = '' } = useParams();
  const { configs } = useConfigQuery();
  const { state } = useLocation();

  const config = useMemo(() => {
    return configs.find((config) => config?.configName === configName && config?.id === state?.id);
  }, [configs, configName]);

  return (
    <Box>
      <BackPageButton sx={{ marginLeft: 2 }} />
      {!!config && <RenderAdminConfig key={config.id} config={config} />}
    </Box>
  );
}

export default AdminCustomConfig;
